<template>
  <GenericComments :lesson-id="lessonId" :comment-service="commentService" />
</template>

<script setup>
import { defineProps } from "vue";
import GenericComments from "../common/GenericComments.vue";
import { createProfessionalDevelopmentCommentService } from "@/services/commentServiceFactory";

defineProps({
  lessonId: {
    type: [String, Number],
    required: true,
  },
});

const commentService = createProfessionalDevelopmentCommentService();
</script>

<style scoped>
/* Styles are now handled by GenericComments component */
</style>
